import {
    SHOW_ERROR_MESSAGE,
    DISBURSEMENTREQUEST_SUCCESSFUL_GET,
    DISBURSEMENTREQUEST_UPDATE_FILTERSTATUS,
    DISBURSEMENTREQUEST_UPDATE_FILTERSTARTDATE,
    DISBURSEMENTREQUEST_UPDATE_FILTERENDDATE,
    DISBURSEMENTREQUEST_SUCCESSFUL_INFO_GET,
    DISBURSEMENTREQUEST_SUCCESSFUL_HISTORY_GET,
    DISBURSEMENTREQUEST_SUCCESSFUL_ANNULMENT
} from 'reducers/constants';

import HttpClient from "utils/HttpClient/HttpClient"

export const fetchDisbursementRequests = (requestData, resolve, reject) => dispatch => {
    new HttpClient(true).get("oga/disbursements/filter", {
        params: requestData
    })
        .then((response) => {
            dispatch({
                type: DISBURSEMENTREQUEST_SUCCESSFUL_GET,
                payload: response.data
            });
            resolve();
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
            resolve();
        });
}

export const updateFilterStatus = (data) => dispatch => {
    dispatch(
        {
            type: DISBURSEMENTREQUEST_UPDATE_FILTERSTATUS,
            payload: data
        }
    )
}

export const updateFilterStartDate = (date) => dispatch => {
    dispatch(
        {
            type: DISBURSEMENTREQUEST_UPDATE_FILTERSTARTDATE,
            payload: date
        }
    )
}

export const updateFilterEndDate = (date) => dispatch => {
    dispatch(
        {
            type: DISBURSEMENTREQUEST_UPDATE_FILTERENDDATE,
            payload: date
        }
    )
}

export const saveDisbursementRequest = (dto, resolve, reject) => dispatch => {
    new HttpClient(true).post("oga/disbursement/request", dto)
        .then((response) => {
            resolve("Successful");
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.response.data.message
            });
            reject("Failed");
        })
}

export const fetchDisbursementInfo = () => dispatch => {
    new HttpClient(true).get("oga/disbursement/info")
        .then((response) => {
            dispatch({
                type: DISBURSEMENTREQUEST_SUCCESSFUL_INFO_GET,
                payload: response.data
            });
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
        });
}

export const fetchDisbursementHistory = (disbursementId, resolve, reject) => dispatch => {
    new HttpClient(true).get("oga/disbursement/history?disbursementId=" + disbursementId)
        .then((response) => {
            dispatch({
                type: DISBURSEMENTREQUEST_SUCCESSFUL_HISTORY_GET,
                payload: response.data
            });
            resolve();
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
            reject();
        });
}

export const doAnnulment = (disbursementId, resolve, reject) => dispatch => {
    new HttpClient(true).post("oga/disbursement/annul?disbursementId=" + disbursementId)
        .then((response) => {
            resolve("Successful");
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.response.data.message
            });
            reject("Failed");
        })
}






// WEBPACK FOOTER //
// ./src/reducers/disbursementrequest/disbursementrequestActions.js